import { createStore, createEvent } from 'effector';

export const $userData = createStore({id: "000a593d-0931-4951-b1cc-d0e93de4f8c1"});

export const setUserData = createEvent();

$userData
    .on(setUserData, (_, value) => value);